var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.9,5.9C0.9,5.8,1,5.7,1,5.6c0.3-0.7,0.9-1.2,1.6-1.2c8.3,0,16.5,0,24.8,0c0.7,0,1.4,0.5,1.6,1.2 c0,0.1,0.1,0.2,0.1,0.3c0,0.2,0,0.4,0,0.7c0,0.1-0.1,0.1-0.1,0.2C28.8,7.5,28.1,8,27.3,8C19.1,8,10.8,8,2.6,8 C1.9,7.9,1.2,7.5,1,6.7c0-0.1-0.1-0.2-0.1-0.2C0.9,6.3,0.9,6.1,0.9,5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.1,15.3c0,0.1-0.1,0.1-0.1,0.2c-0.2,0.7-0.9,1.2-1.7,1.2c-8.2,0-16.5,0-24.7,0c-0.8,0-1.4-0.5-1.7-1.2 c0-0.1-0.1-0.2-0.1-0.2c0-0.2,0-0.4,0-0.7c0-0.1,0.1-0.2,0.1-0.2c0.3-0.7,0.9-1.2,1.7-1.2c8.2,0,16.5,0,24.7,0 c0.8,0,1.4,0.5,1.7,1.2c0,0.1,0.1,0.2,0.1,0.2C29.1,14.9,29.1,15.1,29.1,15.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.1,24.1c0,0.1-0.1,0.1-0.1,0.2c-0.2,0.7-0.9,1.2-1.7,1.2c-8.2,0-16.5,0-24.7,0c-0.8,0-1.4-0.5-1.7-1.2 c0-0.1-0.1-0.2-0.1-0.2c0-0.2,0-0.4,0-0.7c0-0.1,0.1-0.2,0.1-0.2C1.2,22.5,1.8,22,2.6,22c8.2,0,16.5,0,24.7,0 c0.8,0,1.4,0.5,1.7,1.2c0,0.1,0.1,0.2,0.1,0.2C29.1,23.7,29.1,23.9,29.1,24.1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.f2df6b3ecaf6b90fff4b95e539d56bfa.svg";
export { ForwardRef as ReactComponent };